// Convert event coordinates to viewport coordinates
import { findLast } from 'lodash-es';
import { EventOutcomeType } from '@marvelapp/core';
import { getCurrentScreen, getCurrentScale, getCurrentOverlayScreen, getCurrentOverlayHotspot, getScreenStyles, getScreenById, getHotspotByID, } from '../selectors';
import { SCREEN_LAYER, OVERLAY_LAYER, SCROLL_CONTAINER_LAYER, } from '../constants/userTest';
import { getLayerDOMElement } from './userTest';
export function imageToViewport(
// TODO to ship this as a util to use with the events api we need to not rely
// on state (just doing that as shortcut for now as it'll be a chunk of work
// to extract screen and overlay calculations from selectors)
state, events, layer, // TODO we should get layer from event?
event) {
    var screenRelativeCoordinates;
    var scaleFactor = getScale(state);
    if (layer === SCROLL_CONTAINER_LAYER) {
        var layerId = event.object.id;
        var domNode = getLayerDOMElement({ type: layer, id: layerId }).firstChild;
        var coordsRelativeToLayerOrigin = [xCoord(event), yCoord(event)];
        var _a = domNode.getBoundingClientRect(), layerY = _a.top, layerX = _a.left, scaledWidth = _a.width;
        // I forgot we use `scale` to scale the player up and down in playback --  I
        // can't rememeber why we do that as we explicitly decided against that for
        // regular prototype playing.
        //
        // So when reading DOM values we need to account for the scaling
        var hotspot = getHotspotByID(state, layerId);
        var scale = scaledWidth / getScreenById(state, hotspot.destinationScreenID).img.width;
        var screenNode = document.getElementById('currentScreen');
        var screenPos = screenNode.getBoundingClientRect();
        return [
            ((layerX - screenPos.left) / scale + coordsRelativeToLayerOrigin[0]) *
                scaleFactor,
            ((layerY - screenPos.top) / scale + coordsRelativeToLayerOrigin[1]) *
                scaleFactor,
        ];
        // TODO can we unify the calculations for scroll container, screen and
        // overlay? Trying to calculate everything from events was probably a
        // mistake. If/when needed we can think how we might do that (eg pre-process
        // events to annotate with extra data for API consumers). For replay it's
        // simpler (faster?) to read DOM values
    }
    if (layer === SCREEN_LAYER) {
        var screenConfig = getCurrentScreen(state);
        // TODO is this some O(n^2) crap to get the most recent resize event for
        // every mouse move????
        var viewportDimensions = getViewportDimensions(event, events);
        // TODO is this some O(n^2) crap to get the most recent scroll event for
        // every mouse move????
        var mostRecentScreenScrollEvent = getLastScrollEvent(event, events, SCREEN_LAYER);
        screenRelativeCoordinates = getCoordinateRelativeToLayer({
            event: event,
            layerConfig: screenConfig,
            mostRecentLayerScrollEvent: mostRecentScreenScrollEvent,
            layerContainerDimensions: viewportDimensions,
            scaleFactor: scaleFactor,
        });
    }
    else {
        // Overlay
        var hotspot = getCurrentOverlayHotspot(state);
        var coordRelativeToOverlayOrigin = void 0;
        if (!hotspot.isScrollable) {
            // Simply scale the coordinates
            coordRelativeToOverlayOrigin = [
                xCoord(event) * scaleFactor,
                yCoord(event) * scaleFactor,
            ];
        }
        else {
            var overlayConfig = getCurrentOverlayScreen(state);
            var overlayContainerDimensions = {
                width: overlayConfig.img.width * scaleFactor,
                // At the moment scrollable overlays are always the full height of the viewport
                height: getViewportDimensions(event, events).height,
            };
            // TODO yikes we do this to replay every mouse move event!!
            // Must make things slow?
            // We could just read the scroll position from the DOM
            // Maybe mouse events should store the current scroll position too?
            var mostRecentOverlayScrollEvent = getLastScrollEvent(event, events, OVERLAY_LAYER);
            coordRelativeToOverlayOrigin = getCoordinateRelativeToLayer({
                event: event,
                layerConfig: overlayConfig,
                mostRecentLayerScrollEvent: mostRecentOverlayScrollEvent,
                layerContainerDimensions: overlayContainerDimensions,
                scaleFactor: scaleFactor,
            });
        }
        // Offset the coordinates by the position of the overlay in the screen
        var _b = getLayerDOMElement({
            type: OVERLAY_LAYER,
        }).getBoundingClientRect(), layerY = _b.top, layerX = _b.left, scaledWidth = _b.width;
        var scale = scaledWidth / getCurrentOverlayScreen(state).img.width;
        var screenNode = document.getElementById('currentScreen');
        var screenPos = screenNode.getBoundingClientRect();
        screenRelativeCoordinates = [
            ((layerX - screenPos.left) * scaleFactor) / scale +
                coordRelativeToOverlayOrigin[0],
            ((layerY - screenPos.top) * scaleFactor) / scale +
                coordRelativeToOverlayOrigin[1],
        ];
    }
    // If the viewport is wider than the full size image for the current screen
    // the the screen image is centred so we need to adjust the x-coordinate
    // appropriately
    var marginLeft = getScreenStyles(state, true).imageMargin.marginLeft;
    var viewportCoordinates = [
        screenRelativeCoordinates[0] + marginLeft,
        screenRelativeCoordinates[1],
    ];
    // TODO account for trim header setting for mobile prototypes when doing event
    // playback for iOS
    return viewportCoordinates;
}
function getCoordinateRelativeToLayer(_a) {
    // In the general case, the image for a layer will be scaled to fit a
    // container, may have a fixed header or footer, and may be scrolled.
    var event = _a.event, layerConfig = _a.layerConfig, mostRecentLayerScrollEvent = _a.mostRecentLayerScrollEvent, layerContainerDimensions = _a.layerContainerDimensions, scaleFactor = _a.scaleFactor;
    // The diagram below shows how points on the source image translate to the
    // layer container -- the area of width w and height h.
    //     +--------------------------------+              +------------------+
    //     |                                |              |                  |
    //     |  H                             |              +------------------+
    //     |                                |              |                  |
    //     +--------------------------------+              |                  |
    //     |                                |              |                  |
    //     |                                |              |         w        |
    //     |                                |              <------------------>
    //     |                                |              +------------------+ ^
    //     |                                |              | H                | |
    //     |                                |              +------------------+ |
    //     |                                |              |                  | |
    //     |                                |              | B                | |
    //     |                                |              |                  | |
    //     |                                |              |                  | |
    //     |                                |              |                  | h
    //     |                                |              |                  | |
    //     |   B                            |              |                  | |
    //     |                                |              |                  | |
    //     |                                |              +------------------+ |
    //     |                                |              | F                | |
    //     |                                |              +------------------+ v
    //     |                                |              |                  |
    //     |                                |              |                  |
    //     |                                |              +------------------+
    //     |                                |              |                  |
    //     |                                |              +------------------+
    //     |                                |
    //     |                                |
    //     |                                |
    //     +--------------------------------+
    //     |                                |
    //     |  F                             |
    //     |                                |
    //     +--------------------------------+
    // H's coords are just scaled and it is positioned relative to the top left of
    // the container.
    // F's coords relative to the *bottom left* are scaled and it is positioned
    // relative to the bottom left of the container.
    // B's coordinates are scaled, the scroll position is subtracted, and it is
    // positioned relative to the top left of the container. B is about half way down the source image so is placed near the header as
    // the screen is scrolled.
    if (isInHeader(event, layerConfig)) {
        // Simply scale the event coordinates
        return [xCoord(event) * scaleFactor, yCoord(event) * scaleFactor];
    }
    if (isInFooter(event, layerConfig)) {
        // Calculate the distance from the event to the _bottom_ of the image
        var deltaFromEventToBottomOfImage = layerConfig.img.height - yCoord(event);
        // Calculate that distance at the current scale
        var scaledDeltaFromEventToBottomOfImage = deltaFromEventToBottomOfImage * scaleFactor;
        // Subtract that scaled distance from the viewport height
        var scaledYCoord = layerContainerDimensions.height - scaledDeltaFromEventToBottomOfImage;
        return [xCoord(event) * scaleFactor, scaledYCoord];
    }
    // In body
    var scrollPos = calculateLayerScrollPosition({
        mostRecentLayerScrollEvent: mostRecentLayerScrollEvent,
        layerDimensions: layerConfig.img,
        layerContainerDimensions: layerContainerDimensions,
        scaleFactor: scaleFactor,
    });
    // Scale the coordinate and move up/left if the layer is scrolled vertically/horizontally
    return [
        xCoord(event) * scaleFactor - scrollPos[0],
        yCoord(event) * scaleFactor - scrollPos[1],
    ];
}
function isInHeader(event, screen) {
    if (!screen.header) {
        return false;
    }
    return yCoord(event) <= screen.header.y;
}
function isInFooter(event, screen) {
    if (!screen.footer) {
        return false;
    }
    return yCoord(event) >= screen.footer.y;
}
function xCoord(event) {
    return event.trigger.coords[0];
}
function yCoord(event) {
    return event.trigger.coords[1];
}
function getViewportDimensions(event, events) {
    var outcome = findLastEventBefore(event, function (e) { return e.outcome.type === EventOutcomeType.Resize; }, events).outcome;
    return outcome;
}
function getLastScrollEvent(event, events, layer) {
    return findLastEventBefore(event, function (e) {
        return e.outcome.type === EventOutcomeType.Scroll && e.object.type === layer;
    }, events);
}
function calculateLayerScrollPosition(_a) {
    var mostRecentLayerScrollEvent = _a.mostRecentLayerScrollEvent, layerDimensions = _a.layerDimensions, layerContainerDimensions = _a.layerContainerDimensions, scaleFactor = _a.scaleFactor;
    if (!mostRecentLayerScrollEvent) {
        return [0, 0];
    }
    var scrollPos = mostRecentLayerScrollEvent.outcome.coords;
    return [
        scrollPos[0] > 0 // TODO explain this
            ? calculateScrollPosition(scrollPos[0], layerDimensions.width, layerContainerDimensions.width, scaleFactor)
            : 0,
        calculateScrollPosition(scrollPos[1], layerDimensions.height, layerContainerDimensions.height, scaleFactor),
    ];
}
function calculateScrollPosition(pointAlignedWithContainerEdge, screenLengthInDirectionOfScroll, containerLengthInDirectionOfScroll, scaleFactor) {
    // We store scroll position by saying 'point y on the source image was
    // scrolled to align to the top of the layer container.
    // The diagram below shows this.
    // On the left the image is unscrolled. On the right the image is scrolled to
    // align y with the top of the container.
    //                      +----------------+
    //                      |                |
    //                      |                |
    //                      |                |
    //                      |                |
    //                      |                |
    //                      |                |
    //                      |                |
    //                      |                |
    //                      |                |
    //                      |                |
    //                      |                |
    //                      |                |
    //                      |                |
    // +----------------+   +----------------+ <-y
    // |                |   |                |
    // |                |   |                |
    // |                |   |                |
    // |                |   |                |
    // |                |   |                |
    // |                |   |                |
    // |                |   |                |
    // |                |   |                |
    // +----------------+   +----------------+
    // |                |   |                |
    // |                |   +----------------+
    // |                |
    // |                |
    // |                |<-y
    // |                |
    // |                |
    // |                |
    // |                |
    // |                |
    // |                |
    // |                |
    // |                |
    // |                |
    // |                |
    // +----------------+
    // It could be that we _can't_ scroll y to the top so in that case we need to
    // calculate how much the scroll is for the given container.
    // This is shown below.
    //                         +----------------+
    //                         |                |
    //                         |                |
    //                         |                |
    //                         |                |
    //                         |                |
    //                         |                |
    //                         |                |
    //                         |                |
    //                         |                |
    //                         |                |
    //                         |                |
    //                         |                |
    //                         |                |
    //                         |                |
    // +----------------+      +----------------+
    // |                |      |                |
    // |                |      |                |
    // |                |      |                |
    // |                |      |                |
    // |                |      |                |
    // |                |      |                <-y
    // |                |      |                |
    // |                |      |                |
    // +----------------+      +----------------+
    // |                |
    // |                |
    // |                |
    // |                |
    // |                |
    // |                |
    // |                |
    // |                |
    // |                |
    // |                |
    // |                |
    // |                |
    // |                <-y
    // |                |
    // |                |
    // +----------------+
    if ((screenLengthInDirectionOfScroll - pointAlignedWithContainerEdge) *
        scaleFactor >=
        containerLengthInDirectionOfScroll) {
        // We can scroll all the way so scroll position is simply 'y' (scaled)
        return pointAlignedWithContainerEdge * scaleFactor;
    }
    // We can't scroll all the way
    return (pointAlignedWithContainerEdge * scaleFactor -
        containerLengthInDirectionOfScroll +
        (screenLengthInDirectionOfScroll - pointAlignedWithContainerEdge) *
            scaleFactor);
}
function findLastEventBefore(currentEvent, predicate, events) {
    // TODO can we get the event index here?
    var currentEventIndex = events.findIndex(function (e) { return e.id === currentEvent.id; });
    var previousEvents = events.slice(0, currentEventIndex);
    return findLast(previousEvents, predicate);
}
function getScale(state) {
    var scale = getCurrentScale(state);
    // TODO remove this hack to get actual scale value
    return scale(100000) / 100000;
}
